const NaviLinkLogo = {
  name: 'index',
  component: 'NaviLinkLogo',
  props: { href: '/' },
}
const NaviLinkAnalysis = {
  name: 'analysis',
  component: 'NaviLink',
  props: {
    label: '個股',
    href: '/analysis',
    isActiveValidator: ({ currentPath }) => (/^\/analysis\/.*/.test(currentPath)),
  },
}
const NaviButtonPickStock = {
  name: 'screeners',
  component: 'NaviButtonDropdownGroup',
  props: {
    label: '選股',
    topList: [
      { label: '選股功能總覽', href: '/screeners' },
    ],
    groupList: [
      {
        groupName: '常用選股功能',
        groupLinks: [
          { label: '自訂選股', href: '/screeners/custom' },
          { label: '績優股清單', href: '/screeners/quality' },
          { label: '轉機股清單', href: '/screeners/turnaround' },
        ],
      },
      {
        groupName: '指標排行榜選股',
        groupLinks: [
          { label: '月營收排行榜', href: '/screeners/revenues_ranking' },
          { label: '殖利率排行榜', href: '/screeners/dividend_yield_ranking' },
          { label: '本益比排行榜', href: '/screeners/pe_ranking' },
          { label: '毛利率排行榜', href: '/screeners/gross_margin_ranking' },
        ],
      },
    ],
  },
}
const NaviButtonIndustry = {
  name: 'industry',
  component: 'NaviButtonDropdownGroup',
  props: {
    label: '產業',
    groupList: [
      {
        groupName: '觀點',
        groupLinks: [
          { label: '產業報告', href: '/industry_reports', isActiveValidator: ({ currentPath }) => (/^\/industry_reports(\/.*)?/.test(currentPath)) },
          { label: '產業新聞', href: '/news', isActiveValidator: ({ currentPath }) => (/^\/news(\/.*)?/.test(currentPath)) },
        ],
      },
      {
        groupName: '焦點產業',
        groupLinks: [
          { label: '記憶體', href: '/tags/977', isActiveValidator: ({ currentPath }) => (/^\/tags\/977(\/.*)?/.test(currentPath)) },
          { label: 'DRAM', href: '/tags/175', isActiveValidator: ({ currentPath }) => (/^\/tags\/175(\/.*)?/.test(currentPath)) },
          { label: 'NAND Flash', href: '/tags/243', isActiveValidator: ({ currentPath }) => (/^\/tags\/243(\/.*)?/.test(currentPath)) },
          { label: 'IC封測', href: '/tags/21', isActiveValidator: ({ currentPath }) => (/^\/tags\/21(\/.*)?/.test(currentPath)) },
          { label: '晶圓代工', href: '/tags/101', isActiveValidator: ({ currentPath }) => (/^\/tags\/101(\/.*)?/.test(currentPath)) },
          { label: '半導體前段設備', href: '/tags/45077', isActiveValidator: ({ currentPath }) => (/^\/tags\/45077(\/.*)?/.test(currentPath)) },
          { label: '手機處理器', href: '/tags/2971', isActiveValidator: ({ currentPath }) => (/^\/tags\/2971(\/.*)?/.test(currentPath)) },
          { label: 'PC', href: '/tags/7440', isActiveValidator: ({ currentPath }) => (/^\/tags\/7440(\/.*)?/.test(currentPath)) },
        ],
      },
    ],
  },
}

const NaviButtonMarket = {
  name: 'market',
  component: 'NaviButtonDropdownLinks',
  props: {
    label: '市場',
    list: [
      {
        label: '大盤產業',
        href: '/taiex',
        isActiveValidator: ({ currentPath }) => (/^\/taiex(\/.*)?/.test(currentPath)),
      },
      {
        label: '市場焦點',
        href: '/market-trend',
        isActiveValidator: ({ currentPath }) => (currentPath === '/market-trend'),
      },
    ],
  },
}

const NaviLinkPricing = {
  name: 'pricing',
  component: 'NaviLink',
  props: {
    label: '購買',
    href: '/pricing',
    isActiveValidator: ({ currentPath }) => (/^\/pricing(\/.*)?/.test(currentPath)),
  },
}
const NaviButtonMore = {
  name: 'more',
  component: 'NaviButtonDropdownLinks',
  props: {
    label: '更多',
    list: [
      { label: '比較', href: '/compare/tpe' },
      { label: '網誌', href: '/blog' },
      {
        label: '徵才',
        href: 'https://www.cakeresume.com/companies/statementdog/jobs',
        target: '_blank',
        rel: 'nofollow noreferrer',
      },
    ],
  },
}

const NaviLinkFeeds = {
  name: 'feeds',
  component: 'NaviLinkFeeds',
  props: {
    label: '我的追蹤',
    href: '/feeds',
    isActiveValidator: ({ currentPath }) => ['/feeds', '/portfolios'].includes(currentPath),
  },
}
const NaviButtonNotification = {
  name: 'notification',
  component: 'NaviButtonNotification',
  props: { label: '通知' },
}
const NaviButtonSetting = {
  name: 'setting',
  component: 'NaviButtonSetting',
  props: {
    list: [
      { label: '帳號設定', href: '/users/account' },
      { label: '付款設定', href: '/users/account/payment' },
      { label: '重設密碼', href: '/users/account/password' },
    ],
    adminList: [
      {
        label: '後台首頁',
        href: '/admin',
        ruleValidator: ({ currentUser }) => (
          currentUser.roles.includes('admin')
            || currentUser.roles.includes('admin_dev')
        ),
      },
      {
        label: '會員控制',
        href: '/admin/users',
        ruleValidator: ({ currentUser }) => currentUser.roles.includes('admin_users'),
      },
      {
        label: '標籤管理',
        href: '/admin/tags',
        ruleValidator: ({ currentUser }) => currentUser.roles.includes('admin_stocks'),
      },
      {
        label: '新聞編輯',
        href: '/admin/news',
        ruleValidator: ({ currentUser }) => currentUser.roles.includes('admin_news'),
      },
      {
        label: '自訂圖表',
        href: '/custom-chart',
        ruleValidator: ({ currentUser }) => currentUser.roles.includes('admin_dev'),
      },
    ],
  },
}

export const NAVI_LIST_OPTIONS_LAYOUT_LEFT = [
  NaviLinkLogo,
  NaviLinkAnalysis,
  NaviButtonPickStock,
  NaviButtonIndustry,
  NaviButtonMarket,
  NaviLinkPricing,
  NaviButtonMore,
]

export const NAVI_LIST_OPTIONS_LAYOUT_RIGHT = [
  NaviLinkFeeds,
  NaviButtonNotification,
  NaviButtonSetting,
]

export const NOT_SIGNED_IN_NAVI_LIST_OPTIONS_LAYOUT_RIGHT = [
  {
    name: 'user-auth-links',
    component: 'NaviUserAuthLinks',
    props: {
      loginLabel: '登入',
      loginLink: '/users/sign_in',
      registerLabel: '免費註冊',
      registerLink: '/users/sign_up',
    },
  },
]
